module.exports = "pegasus/assets/hexagon-pinterest.png";